import { render } from "./addExchangeReceipt.vue?vue&type=template&id=5753a968"
import script from "./addExchangeReceipt.vue?vue&type=script&lang=js"
export * from "./addExchangeReceipt.vue?vue&type=script&lang=js"

import "./addExchangeReceipt.vue?vue&type=style&index=0&id=5753a968&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__